import PropTypes from 'prop-types'
import React from 'react'
import './Borde.css'

const Borde = React.forwardRef(({ titulo, disabled, error, children }, ref) => {
  const obtenerClases = () => {
    let clase = 'row'
    if (error) {
      clase += ' publicacion-error'
    }
    return clase
  }

  return (
    <div className={obtenerClases()} disabled={disabled} ref={ref}>
      <div className="col">
        <div className="publicacion-titulo-detalle">
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}
          {titulo}
        </div>
        <div className="row publicacion-informacion">
          <div className="col">{children}</div>
        </div>
      </div>
    </div>
  )
})

Borde.displayName = 'Borde'
Borde.propTypes = {
  titulo: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  children: PropTypes.node.isRequired
}

export default Borde
